import React from 'react';
import {Image, View} from 'react-native';
// @ts-expect-error TS(7016): Could not find a declaration file for module 'reac... Remove this comment to see the full error message
import Markdown from 'react-native-markdown-package';
import {get, noop} from 'lodash';

import OptaviaLogoHorizontal from '/asset/image/connect_logo_vertical.png';
import Construction from '/asset/image/construction.png';
import Button from '/component/base/Button';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {MaintenanceBanner} from '/component/partial/MaintenanceBanner';
import {withSafeArea} from '/provider/SafeAreaProvider';
import {useTranslation} from '/provider/TranslationProvider';
import {getFontFamily} from '/util/text.util';

import {styles} from './MaintenancePage.style';

interface MaintenancePageProps {
  maintenance?: {
    page?: {
      title?: string;
      description?: string;
    };
  };
  updateMaintenance?: () => void;
  safeAreaInsets?: {
    top: number;
    bottom: number;
    left: number;
    right: number;
  };
}

const defaultProps: Partial<MaintenancePageProps> = {
  maintenance: {page: {title: '', description: ''}},
  updateMaintenance: noop,
  safeAreaInsets: {top: 0, bottom: 0, left: 0, right: 0},
};

const MaintenancePage: React.FC<MaintenancePageProps> = ({
  maintenance = defaultProps.maintenance,
  updateMaintenance = defaultProps.updateMaintenance,
  safeAreaInsets = defaultProps.safeAreaInsets,
}) => {
  const {ts} = useTranslation('component.screen.MaintenancePage');

  const title =
    get(maintenance, 'page.title', ts('title', 'App under maintenance...')) ||
    '';
  const description =
    get(
      maintenance,
      'page.description',
      ts(
        'description',
        "We'll be back soon with updates to the **OPTA**VIA Connect App!",
      ),
    ) || '';

  return (
    <View style={[styles.base, {paddingTop: safeAreaInsets?.top ?? 0}]}>
      <MaintenanceBanner maintenance={maintenance} />
      <Gutter style={styles.content}>
        <View style={styles.logoContainer}>
          <Image
            style={styles.logo}
            resizeMode="contain"
            source={OptaviaLogoHorizontal}
          />
        </View>
        <View style={styles.constructionContainer}>
          <Image
            style={styles.construction}
            resizeMode="contain"
            source={Construction}
          />
        </View>
        <Text variant="medium" style={[styles.title, getFontFamily('bold')]}>
          {title}
        </Text>
        <Markdown
          styles={{
            paragraph: styles.description,
          }}>
          {description}
        </Markdown>
        <Button
          style={{base: styles.button}}
          testID="refresh-button"
          onPress={updateMaintenance}>
          {ts('login', 'Refresh')}
        </Button>
      </Gutter>
    </View>
  );
};

MaintenancePage.defaultProps = defaultProps;

export default withSafeArea(MaintenancePage);
